import { Dialog as DialogPrimitive } from 'radix-ui';
import { type ReactNode, useRef } from 'react';

import { Button } from '@/components/ui/Button';
import { XStack, YStack } from '@/components/ui/layout/layout';
import { startChatWithPrompt } from '@/features/chat/start-chat-with-prompt';

export const ChangelogPrompt = ({ children }: { children: ReactNode }) => {
  const promptRef = useRef<HTMLDivElement>(null);

  return (
    <YStack className="not-prose my-5 gap-1.5 rounded-xl border border-border py-3 pr-3 pl-4">
      <XStack className="items-center justify-between">
        <span className="text-xs font-medium text-foreground-muted">
          Prompt
        </span>
        <DialogPrimitive.Close asChild>
          <Button
            variant="outline"
            size="xs"
            className="text-xs"
            onClick={() =>
              startChatWithPrompt(promptRef.current?.innerText.trim() ?? '')
            }
          >
            Try
          </Button>
        </DialogPrimitive.Close>
      </XStack>
      <div ref={promptRef} className="pr-1 text-foreground [&_p+p]:mt-2">
        {children}
      </div>
    </YStack>
  );
};
